'use client';
import e__default, { useState, useMemo } from 'react';
import { SwanCollectionContext } from './collection.context.js';

function CollectionContextProvider(l) {
    let { children: i, items: n } = l, [c, d] = useState(l.disabledKeys), [a, m] = useState(l.disabledKeys);
    c !== a && (d(c), m(c));
    let [s, f] = useState(), p = useMemo(()=>({
            items: n,
            childItems: s,
            setChildItems: f,
            disabledKeys: c,
            setDisabledKeys: d
        }), [
        n,
        s,
        f,
        c,
        d
    ]);
    return e__default.createElement(SwanCollectionContext.Provider, {
        value: p
    }, i);
}

export { CollectionContextProvider };
